import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    min-height: 0;\n    min-width: 0;\n    box-sizing: border-box;\n  }\n\n  html {\n    font-size: 62.5%;\n  }\n\n  body {\n    background: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "rem;\n    line-height: ", ";\n    min-height: 100vh;\n  }\n\n  address {}\n\n  article {}\n\n  aside {}\n\n  footer {}\n\n  header {}\n\n  main {}\n\n  nav {}\n\n  section {}\n\n  img { width: 100%; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from "styled-components";
import normalize from "polished/lib/mixins/normalize";
var GlobalStyles = createGlobalStyle(_templateObject(), normalize(), function (props) {
  return props.theme.baseBackgroundColor;
}, function (props) {
  return props.theme.baseBodyColor;
}, function (props) {
  return props.theme.fontStacks.body;
}, function (props) {
  return props.theme.fontSizes.p;
}, function (props) {
  return props.theme.lineHeight;
});
export default GlobalStyles;